import Button from "shared/UI/Buttons/Button";
import { useTranslation } from "react-i18next";

export const ExportReport = () => {
  const { t } = useTranslation();
  return (
    <Button
      className="max-w-[200px]"
      text={t("dashboard.export")}
      type="button"
      onClick={() => document.dispatchEvent(new CustomEvent("exportReport", {}))}
    />
  );
};
